// Put your main getters here

import _ from "lodash";

export default {
  doubleCounter: (state) => {
    return state.counter * 2;
  },
  user: (state) => {
    return state.user;
  },
  groupedLots: (state) => {
    return _(state.process.markedRows)
      .groupBy("lot")
      .map((lot, id) => ({
        value: parseInt(id),
        text: _.get(_.find(lot, "lot_number"), "lot_number")
      }))
      .value();
  },
  isLoggedIn: (state) => !!state.token,
  authStatus: (state) => state.status,
  getScopedMenu: (state) => {
    let array = [];
    const menu = state.user.MENU;
    for (let me of menu) {
      if (me.children) {
        for (let child of me.children) {
          array.push(child.url);
        }
      }
    }
    return array;
  },
  getCustomFieldsList: (state) => {
    let arr = [];
    for (var key in state.user.content_custom_fields) {
      if (state.user.content_custom_fields.hasOwnProperty(key)) {
        const elements = _.map(state.user.content_custom_fields[key], "name");
        for (var i in elements) {
          arr.push("custom_fields." + elements[i]);
        }
      }
    }
    return arr;
  }
};
